import { render } from "./Clever.vue?vue&type=template&id=75ea57b0&scoped=true"
import script from "./Clever.vue?vue&type=script&lang=js"
export * from "./Clever.vue?vue&type=script&lang=js"

import "./Clever.vue?vue&type=style&index=0&id=75ea57b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ea57b0"]])

export default __exports__